import type { SelectOption } from '@/components/forms';

import type { CompanyRole, CompanyUserStatus } from './types/companyUser.types';

/** Display labels for the company roles (RBAC.md §3). */
export const ROLE_LABELS: Record<CompanyRole, string> = {
  OWNER: 'Owner',
  ADMIN: 'Admin',
  RECRUITER: 'Recruiter',
  HIRING_MANAGER: 'Hiring Manager',
  INTERVIEWER: 'Interviewer',
};

/**
 * The assignable roles for invite/edit dialogs. Owner is deliberately absent — ownership is granted
 * at company founding or moved via Transfer Ownership, never assigned as a role (RBAC BR #4).
 */
export const ASSIGNABLE_ROLE_OPTIONS: SelectOption[] = [
  { value: 'ADMIN', label: ROLE_LABELS.ADMIN },
  { value: 'RECRUITER', label: ROLE_LABELS.RECRUITER },
  { value: 'HIRING_MANAGER', label: ROLE_LABELS.HIRING_MANAGER },
  { value: 'INTERVIEWER', label: ROLE_LABELS.INTERVIEWER },
];

export const STATUS_LABELS: Record<CompanyUserStatus, string> = {
  INVITED: 'Invited',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
};
